import { Directive, ElementRef, Input} from '@angular/core';
import { HTML } from '../utils/html';

@Directive({
  selector: '[trimRichtextAriaLabel]'
})
export class TrimRichtextAriaLabelDirective {

  @Input() set trimRichtextAriaLabel(content: string) {
    this.elementRef.nativeElement.setAttribute('aria-label', HTML.trim(content));
  }

  constructor(protected elementRef: ElementRef) {
  }
}